import actionCreatorFactory from 'typescript-fsa';
import { SortingGeneric, TableColumnWidthInfoGeneric } from '../history-table-settings/types';
import { constants } from './constants';
import { NotificationHistoryDtoKeys } from './types';

const actionCreator = actionCreatorFactory("notification-table-settings");

export const setColumnOrderAction = actionCreator<NotificationHistoryDtoKeys[]>(constants.SET_COLUMN_ORDER);
export const setColumnSizeAction = actionCreator<TableColumnWidthInfoGeneric<NotificationHistoryDtoKeys>[]>(
	constants.SET_COLUMN_SIZES
);
export const setColumnSortingAction = actionCreator<SortingGeneric<NotificationHistoryDtoKeys>[]>(
	constants.SET_COLUMN_SORTING
);
